// extracted by mini-css-extract-plugin
export var container = "LoginForm-module--container--Hf-dL";
export var fbWrapper = "LoginForm-module--fb-wrapper--vl1XI";
export var formwrapper = "LoginForm-module--formwrapper--w-lr2";
export var googleWrapper = "LoginForm-module--google-wrapper--HRH4L";
export var iconWrapper = "LoginForm-module--icon-wrapper--awsts";
export var loginText = "LoginForm-module--login-text--NFyrJ";
export var loginWrapper = "LoginForm-module--login-wrapper--WmWtf";
export var textWrapper = "LoginForm-module--text-wrapper--FaST8";